<template>
  <div class="website-wrapper">
    <van-row gutter="20">
      <van-col span="12">
        <div class="box">
          <div class="title">{{ $t('资质认证') }}</div>
          <img src="../../../assets/img/home/website_2.png" alt="" />
        </div>
      </van-col>
      <van-col span="12">
        <div class="box">
          <div class="title">{{ $t('合作伙伴') }}</div>
          <img src="../../../assets/img/home/website_3.png" alt="" />
        </div>
      </van-col>
    </van-row>
    <!--    <img class="logo" v-lazy="logoSrc" alt="" />-->
    <!--    <div class="desc">-->
    <!--      <p>本网站提供包括风险在内的在线赌场体验。</p>-->
    <!--      <p>我们网站的用户必须是 18+。</p>-->
    <!--      <p>对于违反您当地与iGaming相关的法律，我们概不负责。</p>-->
    <!--      <p>负责任地玩，在{{ websiteName }}中玩得开心。</p>-->
    <!--    </div>-->
    <img class="website-img" src="../../../assets/img/home/website_1.png" alt="" />
    <!-- <div class="copyright">Copyright (C) {{ year }} All Rights Reserved.</div> -->
  </div>
</template>

<script setup lang="ts">
// import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs, useTenantStore } from '@star/stores';

const year = new Date().getFullYear();
const router = useRouter();
const { logoSrc, websiteName } = storeToRefs(useTenantStore());
</script>

<style lang="less" scoped>
.website-wrapper {
  padding: 33px;
  color: #7b7b7b;

  .box {
    width: 100%;

    .title {
      font-size: 33px;
      font-weight: 400;
      padding: 33px 0;
    }

    img {
      width: 100%;
    }
  }

  .logo {
    height: 78px;
    margin-top: 70px;
  }

  .desc {
    color: #909297;
    font-size: 33px;
    font-weight: 400;
    line-height: 60px;
    margin-top: 30px;
  }

  .website-img {
    height: 66px;
    margin-top: 66px;
  }

  .copyright {
    font-size: 33px;
    font-weight: 400;
    line-height: 60px;
    color: #000;
    margin-top: 60px;
  }
}

.banner-swiper {
  height: 366px;

  .van-swipe-item {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .swiper-item-image {
      height: 100%;
    }
  }

  :deep(.van-swipe__indicators) {
    display: flex;
    align-items: center;

    .van-swipe__indicator {
      width: 16px;
      height: 16px;
      background: rgb(0 0 0 / 50%);
      border-radius: 16px;

      &.van-swipe__indicator--active {
        width: 22px;
        height: 22px;
      }
    }
  }
}
</style>
